"use strict";
/**
 * Markets Fetcher
 * Main fetching logic with provider selection
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMarkets = fetchMarkets;
exports.fetchEventMarkets = fetchEventMarkets;
exports.getEventMarkets = getEventMarkets;
const state_1 = require("../state");
const cache_1 = require("./cache");
const constants_1 = require("./constants");
const registry_1 = require("../venues/registry");
/**
 * Fetch markets from API with provider selection
 * Branches on dataSource to fetch from Kalshi or Polymarket
 */
async function fetchMarkets(category, pmTagSlug) {
    const state = (0, state_1.getState)();
    const dataSource = state.dataSource;
    try {
        // Update state: loading
        (0, state_1.updateState)({
            isLoadingMarkets: true,
            errorMessage: null,
        });
        // Store category for reference
        (0, cache_1.setCurrentCategory)(category);
        const displayEvents = await (0, registry_1.getVenue)(dataSource).fetchEvents({
            category,
            tagSlug: pmTagSlug,
        });
        // Update state: success
        (0, state_1.updateState)({ isLoadingMarkets: false });
        return displayEvents;
    }
    catch (error) {
        console.error("Failed to fetch markets:", error);
        (0, state_1.updateState)({
            isLoadingMarkets: false,
            errorMessage: "Failed to fetch markets. Please try again.",
        });
        throw error;
    }
}
/**
 * Fetch all markets for an event with caching
 * Branches on dataSource to handle Kalshi or Polymarket
 */
async function fetchEventMarkets(eventId) {
    const state = (0, state_1.getState)();
    const dataSource = state.dataSource;
    try {
        // Check if we have cached markets for this event
        const cached = (0, cache_1.getCachedEventMarkets)(eventId);
        if (cached && Date.now() - cached.timestamp < constants_1.MARKET_CACHE_DURATION) {
            console.log(`Using cached markets for event: ${eventId}`);
            return cached.markets;
        }
        const convertedMarkets = await (0, registry_1.getVenue)(dataSource).fetchEventMarkets(eventId);
        // Cache the results
        (0, cache_1.setCachedEventMarkets)(eventId, convertedMarkets);
        return convertedMarkets;
    }
    catch (error) {
        console.error("Failed to fetch markets for event:", error);
        throw error;
    }
}
/**
 * Get cached markets for an event
 * Returns undefined if not cached or cache expired
 */
function getEventMarkets(eventTicker) {
    const cached = (0, cache_1.getCachedEventMarkets)(eventTicker);
    // Return if cache exists and is fresh
    if (cached && Date.now() - cached.timestamp < constants_1.MARKET_CACHE_DURATION) {
        return cached.markets;
    }
    // Clear expired cache
    if (cached) {
        (0, cache_1.deleteCachedEventMarkets)(eventTicker);
    }
    return undefined;
}
